import _ from 'lodash';
import { createReducer, on } from '@ngrx/store';
import * as P2PActions from './p2p.actions';
import { EntityState, EntityAdapter, createEntityAdapter } from '@ngrx/entity';

export const p2pFeatureKey = 'peerToPeer';

export interface State extends EntityState<any>{
  component: string | { name: string, payload: any };
  P2PCampaigns: any[];
  SelectedP2PCampaign: any;
  P2PFundraiserReport: any[];
  P2PDonations: any[];
  transactions: any[];
  pledges: any[];
}

export const adapter: EntityAdapter<any> = createEntityAdapter<any>();

export const initialState: State = adapter.getInitialState({
  component: {
    name: 'p2p-campaign-list',
    payload: {}
  },
  P2PCampaigns: [],
  SelectedP2PCampaign: null,
  P2PFundraiserReport: [], // all fundraisers info
  P2PDonations: [], // certain fundraiser info
  transactions: [],
  pledges: []
});

export const reducer = createReducer(
  initialState,

  on(P2PActions.loadP2PCampaignList, state => state),
  on(P2PActions.loadP2PCampaignListSuccess, (state, action) => {
    return {
      ...state,
      P2PCampaigns: action.data
    };
  }),
  on(P2PActions.loadP2PCampaignListFailure, (state, action) => state),

  on(P2PActions.selectP2PCampaign, state => state),
  on(P2PActions.selectP2PCampaignSuccess, (state, action) => {
    return {
      ...state,
      SelectedP2PCampaign: action.data
    };
  }),
  on(P2PActions.selectP2PCampaignFailure, (state, action) => state),

  on(P2PActions.peerToPeerReport, state => state),
  on(P2PActions.peerToPeerReportSuccess, (state, action) => {

    const P2PFundraiserReport = action.data;
    
    return {
      ...state,
      P2PFundraiserReport
    };
  }),
  on(P2PActions.peerToPeerReportFailure, (state, action) => state),

  on(P2PActions.peerToPeerInfo, state => state),
  on(P2PActions.peerToPeerInfoSuccess, (state, action) => {

    const P2PDonations = action.data;

    return {
      ...state,
      P2PDonations,
      transactions : P2PDonations.transactions,
      pledges : P2PDonations.pledges
    };
  }),
  on(P2PActions.peerToPeerInfoFailure, (state, action) => state),

  on(P2PActions.addP2PDonation, state => state),
  on(P2PActions.addP2PDonationSuccess, (state, action) => {

    const updatedData = action.data;
    const peerToPeerId = action.data.peerToPeerId;

    const updatedDonationsFundraiserReport = state.P2PFundraiserReport.map((fundraiser) => {
      if (fundraiser.id === peerToPeerId) {
        return {
          ...fundraiser,
          raised: fundraiser.raised + updatedData.amount,
        };
      } else {
        return fundraiser;
      }
    });

    return {
      ...state,
      P2PFundraiserReport: updatedDonationsFundraiserReport,
    };
  }),
  on(P2PActions.addP2PDonationFailure, (state, action) => state),

  on(P2PActions.updateP2P, state => state),
  on(P2PActions.updateP2PSuccess, (state, action) => {
    const updatedData = action.data;
    const peerToPeerId = updatedData.id

    const updatedFundraiserReport = state.P2PFundraiserReport.map((fundraiser) => {
      if (fundraiser.id === peerToPeerId) {
        return {
          ...fundraiser,
          displayName: updatedData.displayName,
          goal: updatedData.goal,
          createdByName: updatedData.createdByName,
          userInfo: {
            ...fundraiser.userInfo,
            name: updatedData.userInfo.name,
          },
        };
      } else {
        return fundraiser;
      }
    });
    
    return {
      ...state,
      P2PFundraiserReport: updatedFundraiserReport,
    };
  }),
  on(P2PActions.updateP2PFailure, (state, action) => state),

  on(P2PActions.deleteP2PItem, state => state),
  on(P2PActions.deleteP2PItemSuccess, (state, action) => {
    
    const peerToPeerId = action.data
    
    const updatedFundraiserReport = state.P2PFundraiserReport.filter((fundraiser) => {
      return fundraiser.id !== peerToPeerId;
    });

    return {
      ...state,
      P2PFundraiserReport: updatedFundraiserReport
    };
  }),
  on(P2PActions.deleteP2PItemFailure, (state, action) => state),

  on(P2PActions.saveP2PEventCount, state => state),
  on(P2PActions.saveP2PEventCountSuccess, (state, action) => {
    const eventCount = action.data.eventCount;

    const updatedFundraiserReport = state.P2PFundraiserReport.map((fundraiser) => {
      if (fundraiser.id === action.data.p2pId) {
        return {
          ...fundraiser,
          eventCount: eventCount
        };
      } else {
        return fundraiser;
      }
    });
    
    return {
      ...state,
      P2PFundraiserReport: updatedFundraiserReport
    };
  }),
  on(P2PActions.saveP2PEventCountFailure, (state, action) => state),
);

